import { FETCH_ALL_NOTIFICATIONS_PENDING, FETCH_ALL_NOTIFICATIONS_SUCCESS } from "../types";
import { getAllNotificationsService } from "../../services/notification.service";
import axios from "axios";
import { apiUrl } from "../../constant";


const getAllNotifcationsPending = () => ({
    type: FETCH_ALL_NOTIFICATIONS_PENDING
});
const getAllNotifcationsSuccess = (response) => ({
    type: FETCH_ALL_NOTIFICATIONS_SUCCESS,
    payload: response,
});

export const getAllNotifications = (data) => {
    return (dispatch) => {
        dispatch(getAllNotifcationsPending());
        getAllNotificationsService(data).then((result) => {
            dispatch(getAllNotifcationsSuccess(result.data.EntityList || []));
        }).catch((error) => {
            console.log(error)
        });
    };
};

export const updateNotification = (data) => {
    return axios.put(`${apiUrl}/api/IncomingPackage/MarkExportedFileAsIsDownloaded`, data);
};
